export default __webpack_public_path__ + "static/media/shopping-m.1ca68b40.jpg";